










import { Component, Vue } from 'vue-property-decorator'
import { TagsViewModule } from '@/store/modules/tags-view'
import { CacheModule } from '@/store/modules/cache'
@Component({
  name: 'AppMain'
})
export default class extends Vue {
  get cachedViews () {
    return TagsViewModule.cachedViews
  }

  get key () {
    return this.$route.path
  }

  mounted () {
    CacheModule.GetSystemType()
    CacheModule.GetDicts({
      key: 'vtdTaskState,talentUserAuditState,requirementState,talentUserLevelState,dataState,rewardTaskState,taskScreenshotType,vtdFromType'
    })
    // CacheModule.GetShopLabelDicts()
  }
}
